// <Spacing /> example from terrace

// we'd typically want to avoid this but as the heading and paragraph margins
// are still settling, we will need to use this liberally
import styled from "styled-components";
export const Spacing = styled.div.withConfig({
  displayName: "Spacing",
  componentId: "sc-9g6s6s-0"
})(["", " ", " ", " ", ""], props => props.marginRight && "margin-right: ".concat(props.marginRight, "px;"), props => props.marginBottom && "margin-bottom: ".concat(props.marginBottom, "px;"), props => props.bottom && "margin-bottom: ".concat(props.bottom * 5, "px;"), props => props.right && "margin-right: ".concat(props.right * 5, "px;"));
export const SpacingSpan = styled(Spacing).attrs({
  as: "span"
}).withConfig({
  displayName: "Spacing__SpacingSpan",
  componentId: "sc-9g6s6s-1"
})([""]);
export default Spacing;

// import React from "react";
// import PropTypes from "prop-types";
// // import classNames from "classnames";
// // import Styles from "./text.scss";

// // should it be a span or inline-block-div?
// export const Spacing = props => (
//   <div style={{ marginBottom: `${props.bottom * 5}px` }} />
// );
// Spacing.propTypes = {
//   bottom: PropTypes.number.isRequired
// };

// export default Spacing;